import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { CancellationConfigItemResource } from "../types/cancellationConfigItem";

export const cancellationConfigItemService = {
	indexKey: (shopItemId: Id) => ["shop-items", `${shopItemId}`, "cancellation-config-items"],
	index: (shopItemId: Id) =>
		axios.get<LaravelResponse<CancellationConfigItemResource[]>>(
			keyToUrl(cancellationConfigItemService.indexKey(shopItemId)),
		),
};
